import React from "react";
import {
  FaWallet,
  FaChartLine,
  FaHandHoldingUsd,
  FaExchangeAlt,
  FaRobot,
  FaShieldAlt,
  FaMobileAlt,
} from "react-icons/fa";

function StakingAndYield() {
  return (
    <>
      <div className="services-style-five-area default-padding bottom-less">
        <div className="container">
          <div className="left-heading">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <h4 className="sub-title">Xeer Features</h4>
                <div className="right">
                  <h2 className="title">
                    Key Features & Functionalities of a Crypto Banking Platform
                  </h2>
                  <p>
                    Explore essential tools and innovative functionalities that
                    empower users to seamlessly manage, transact, and grow their
                    digital assets within a secure and compliant crypto banking
                    ecosystem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="services-style-five-items">
            <div className="row">
              {/* 1 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaWallet size={45} />
                  </div>
                  <h4>Multi-Currency Wallet Integration</h4>
                  <p>
                    Support for various cryptocurrencies, allowing users to
                    store, send, receive, and swap assets with ease.
                  </p>
                </div>
              </div>

              {/* 2 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaChartLine size={45} />
                  </div>
                  <h4>Staking and Yield Generation</h4>
                  <p>
                    Enable users to earn passive income by staking and farming
                    crypto assets with multiple yield options.
                  </p>
                </div>
              </div>

              {/* 3 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaHandHoldingUsd size={45} />
                  </div>
                  <h4>Crypto-Backed Loans and Credit</h4>
                  <p>
                    Access loans against crypto holdings with flexible repayment
                    and competitive interest rates.
                  </p>
                </div>
              </div>

              {/* 4 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaExchangeAlt size={45} />
                  </div>
                  <h4>Fiat On-Ramp and Off-Ramp</h4>
                  <p>
                    Buy and sell crypto using fiat currencies through seamless
                    payment gateway integration.
                  </p>
                </div>
              </div>

              {/* 5 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaRobot size={45} />
                  </div>
                  <h4>Automated Trading and Investment Bots</h4>
                  <p>
                    Automate trading strategies using advanced bots to maximize
                    returns and reduce risks.
                  </p>
                </div>
              </div>

              {/* 6 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaShieldAlt size={45} />
                  </div>
                  <h4>Regulatory Compliance and KYC/AML</h4>
                  <p>
                    Ensure secure operations with KYC/AML compliance,
                    encryption, and real-time monitoring systems.
                  </p>
                </div>
              </div>

              {/* 7 */}
              <div className="col-xl-3 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-3">
                    <FaMobileAlt size={45} />
                  </div>
                  <h4>Intuitive User Interface and Mobile Support</h4>
                  <p>
                    A responsive and user-friendly interface optimized for both
                    mobile and desktop experiences.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StakingAndYield;
